import axios from '@/services/api'

/**
 * @param {string} query
 *
 * @returns {Promise<Object>}
 */
export const fetchForumCategories = (query = '') => {
	const url = `/api/threads-categories${query}`
	return axios.get(url)
}

/**
 * @param {string} query
 *
 * @returns {Promise<Object>}
 */
export const fetchForums = (query = '') => {
	const url = `/api/threads${query}`
	return axios.get(url)
}

/**
 * @param {number} forumId
 *
 * @returns {Promise<Object>}
 */
export const getForum = (forumId) => {
	const url = `/api/threads/${forumId}`
	return axios.get(url)
}

/**
 * @param {number} forumId
 *
 * @returns {Promise<Object>}
 */
export const getForumComments = (forumId) => {
	const url = `/api/thread-replies?thread_id=${forumId}`
	return axios.get(url)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const addPost = (data) => {
	const url = `/api/threads`
	return axios.post(url, data)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const forumFollow = (data) => {
	const url = `/api/forum-follow`
	return axios.post(url, data)
}

/**
 * @param {String} id
 *
 * @returns {Promise<Object>}
 */
export const forumUnfollow = (id) => {
	const url = `/api/forum-follow/${id}`
	return axios.delete(url)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */

export const editForum = ({ id, data }) => {
	const url = `/api/threads/${id}`
	return axios.put(url, data)
}

/**
 * @param {number} communityId
 *
 * @returns {Promise<Object>}
 */

export const getCommunity = (communityId) => {
	const url = `/api/threads-categories/view?category_type=1&id=${communityId}`
	return axios.get(url)
}

/**
 * @param {Object} data
 *
 * @returns {Promise<Object>}
 */
export const sendReport = (data) => {
	const url = `/api/inappropriate`
	return axios.post(url, data)
}
